import { render, staticRenderFns } from "./kycInfo.vue?vue&type=template&id=4f6bb4fa&scoped=true&"
import script from "./kycInfo.vue?vue&type=script&lang=js&"
export * from "./kycInfo.vue?vue&type=script&lang=js&"
import style0 from "./kycInfo.vue?vue&type=style&index=0&id=4f6bb4fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f6bb4fa",
  null
  
)

export default component.exports